module.exports = __webpack_public_path__ + "img/st-sparepart.9dfeb39f.jpg";